import { IResource } from "./api-helper";

export const concatQuery = (queries: any) => {
    let queryString = "";
    Object.keys(queries).forEach((key) => {
        const query = `${key}=${queries[key]}`;
        queryString = queryString ? `${queryString}&${query}` : query;
    });
    return queryString;
};

export const concatResource = (resource: IResource) => {
    let resourceString = "";
    if (resource.id && resource.name) {
        resourceString = `${resource.name}/${resource.id}`;
    } else if (resource.name) {
        resourceString = `${resource.name}`;
    } else {
        resourceString = "";
    }
    return resourceString;
};
